<template>
  <div>
    <div id="view-sub-nav">
      <v-btn variant="outlined" color="primary" @click="addItem">Create New Item</v-btn>
      <v-spacer />
      <v-text-field
        v-model="tableSearch"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
        density="compact"
        :clearable="true"
      ></v-text-field>
    </div>
    <v-data-table
      v-if="data"
      :items="data.types"
      :headers="headers"
      :sort-by="[{ key: 'id', order: 'asc' }]"
      :items-per-page="-1"
      :search="tableSearch"
    >
      <template v-slot:item.name="{ item }">
        <v-text-field
          class="ma-0 pa-0"
          :style="{ fontSize: '13px' }"
          v-model="item.name"
          @blur="update"
          hide-details
        ></v-text-field>
      </template>
      <template v-slot:item.department="{ item }">
        <v-select
          v-model="item.department"
          :style="{ fontSize: '13px' }"
          :items="departments"
          density="compact"
          hide-details
          @update:model-value="update"
        ></v-select>
      </template>
      <template v-slot:item.expense="{ item }">
        <v-switch
          v-model="item.expense"
          :style="{ fontSize: '13px' }"
          density="compact"
          hide-details
          @update:model-value="update"
        >
        </v-switch>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import uid from 'uid'
import { db } from '@/js/db'
import { doc, updateDoc } from 'firebase/firestore'

export default {
  name: 'CockupSettings',
  data() {
    return {
      loading: true,
      tableSearch: null,
      headers: [
        {
          title: 'Name',
          sortable: true,
          key: 'name'
        },
        {
          title: 'Department',
          sortable: true,
          key: 'department'
        },
        {
          title: 'Our Expense',
          key: 'expense'
        }
      ],
      submitting: false,
      data: null,
      departments: [
        {
          text: 'Sales',
          value: 'sales'
        },
        {
          text: 'Production',
          value: 'prod'
        }
      ]
    }
  },
  async mounted() {
    await this.$live('data', doc(db, 'settings', 'cockup-settings'))
    this.loading = false
  },
  methods: {
    addItem() {
      this.data.types.push({
        id: uid(32),
        name: null,
        department: null
      })
    },
    update() {
      console.log('changed')
      // update in firebase
      updateDoc(doc(db, 'settings', 'cockup-settings'), {
        types: this.data.types
      })
    }
  }
}
</script>
